export const Button = ({ label, onClick, className }) => (
  <button
    onClick={onClick}
    className={`px-4 py-2 bg-[#ffcc00] text-[#000000] ml-auto hover:shadow-2xl transition-transform duration-200 hover:scale-105 hover:bg-[#ffcc00] active:scale-95 rounded-full text-center font-medium font-MTNfont ${className}`}
  >
    {label}
  </button>
);
